import { cn } from "@/lib/utils";

const base =
  "inline-flex items-center justify-center gap-2 font-display font-bold rounded-full transition-all duration-200 ease-bounce select-none focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ring/30 active:scale-95 disabled:opacity-50 disabled:pointer-events-none";

const sizes = {
  sm: "min-h-[44px] px-5 text-sm",
  md: "min-h-[52px] px-7 text-base",
  lg: "min-h-[60px] px-9 text-lg",
};

const variants = {
  primary: "bg-primary text-primary-foreground shadow-glow hover:-translate-y-0.5 hover:brightness-[1.04]",
  secondary: "bg-secondary text-secondary-foreground hover:-translate-y-0.5 hover:brightness-[1.03]",
  teal: "bg-teal text-teal-foreground hover:-translate-y-0.5 hover:brightness-[1.03]",
  outline: "border-2 border-border bg-transparent text-foreground hover:border-primary hover:text-primary-strong hover:-translate-y-0.5",
  ghost: "bg-transparent text-foreground hover:bg-muted",
  soft: "bg-accent text-accent-foreground hover:-translate-y-0.5 hover:brightness-[0.98]",
  destructive: "bg-destructive text-destructive-foreground hover:-translate-y-0.5 hover:brightness-[1.03]",
};

export function BloomButton({
  variant = "primary",
  size = "md",
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  fullWidth,
  className,
  children,
  ...props
}) {
  return (
    <button
      className={cn(base, sizes[size], variants[variant], fullWidth && "w-full", className)}
      {...props}
    >
      {LeftIcon && <LeftIcon size={20} weight="bold" />}
      {children}
      {RightIcon && <RightIcon size={20} weight="bold" />}
    </button>
  );
}

export default BloomButton;
